import { Outlet, useParams } from 'react-router';

import { useCampaignType } from '@/hooks/campaign-type';
import { useTokenCampaign } from '@/hooks/token-campaign';

import { FullPageLoader } from '@/components/full-page-loader/full-page-loader';

export function CampaignSyncLayout() {
  const { campaignType, campaignId } = useParams();
  const { isTokenCampaign } = useCampaignType();

  const { isPending } = useTokenCampaign(
    isTokenCampaign(campaignType) ? campaignId : undefined
  );

  if (isPending) {
    return <FullPageLoader />;
  }

  return <Outlet />;
}
